// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	CONTAINER: '[data-fragment="Usp.container"]',
	ITEM: '[data-fragment="Usp.item"]',
	BTN_PREV: '[data-fragment="Usp.btnPrev"]',
	BTN_NEXT: '[data-fragment="Usp.btnNext"]',
};

class Usp extends WebComponent {
	constructor(props) {
		super(props);

		this.state = {
			containerTranslate: 0,
			containerStart: true,
			containerEnd: false,
		};
	}

	didMount() {
		this.items = this.element.querySelectorAll(fragments.ITEM);
		this.container = this.element.querySelector(fragments.CONTAINER);
		this.on('click', fragments.BTN_PREV, () => this.slide('right'));
		this.on('click', fragments.BTN_NEXT, () => this.slide('left'));
		document.addEventListener('touchstart', this.handleTouchStart, false);
		this.element.addEventListener('touchmove', this.handleTouchMove, false);
		this.xDown = null;
		this.yDown = null;
		this.itemsWidth = 0;
		for (let i = 0; i < this.items.length; i++) {
			this.itemsWidth += this.items[i].offsetWidth;
		}
	}

	willUnMount() {
	}

	slide = (direction: string) => {
		if (window.innerWidth < 1280) {
			const { containerTranslate } = this.state;
			let newTranslate = containerTranslate;
			this.setState({
				containerStart: false,
				containerEnd: false,
			});
			if (direction === 'left') {
				if (window.innerWidth < 768) {
					newTranslate = containerTranslate - this.items[0].offsetWidth;
					if (Math.abs(newTranslate) >= this.itemsWidth - this.items[0].offsetWidth) {
						newTranslate = (this.itemsWidth - this.items[0].offsetWidth) * -1;
						this.setState({ containerEnd: true });
					}
				} else if (window.innerWidth < 992) {
					newTranslate = (this.itemsWidth - 720) * -1;
					this.setState({ containerEnd: true });
				} else if (window.innerWidth < 1280) {
					newTranslate = (this.itemsWidth - 940) * -1;
					this.setState({ containerEnd: true });
				}
			} else if (direction === 'right') {
				if (window.innerWidth < 768) {
					newTranslate = containerTranslate + this.items[0].offsetWidth;
					if (newTranslate >= 0) {
						newTranslate = 0;
						this.setState({ containerStart: true });
					}
				} else {
					newTranslate = 0;
					this.setState({ containerStart: true });
				}
			}
			this.setState({
				containerTranslate: newTranslate,
			});
		}
	}

	handleTouchStart = (e) => {
		const firstTouch = e.touches[0];
		this.xDown = firstTouch.clientX;
		this.yDown = firstTouch.clientY;
	};

	handleTouchMove = (e) => {
		if (!this.xDown || !this.yDown) {
			return;
		}
		const xUp = e.touches[0].clientX;
		const yUp = e.touches[0].clientY;
		const xDiff = this.xDown - xUp;
		const yDiff = this.yDown - yUp;
		if (Math.abs(xDiff) > Math.abs(yDiff)) {
			if (xDiff > 0) {
				this.slide('left');
			} else {
				this.slide('right');
			}
		}
		this.xDown = null;
	};

	update() {
		const {
			containerTranslate,
			containerStart,
			containerEnd,
		} = this.state;
		classNames(this.element, { 'usp--container-start': containerStart });
		classNames(this.element, { 'usp--container-end': containerEnd });
		this.container.style.transform = `translateX(${containerTranslate}px)`;
	}
}

export default Usp;



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/Usp.js